import * as ActionTypes from './index';
import {actionCreator} from "../helpers/functions";

export const changePendingChangeState = actionCreator(ActionTypes.CHANGE_PENDING_CHANGE_STATE);

export const changePendingChangeStateSuccess = actionCreator(ActionTypes.CHANGE_PENDING_CHANGE_STATE_SUCCESS);

export const changePendingChangeStateFailed = actionCreator(ActionTypes.CHANGE_PENDING_CHANGE_STATE_FAILED);

export const moderatePendingChange = actionCreator(ActionTypes.MODERATE_PENDING_CHANGE);

export const moderatePendingChangeSuccess = actionCreator(ActionTypes.MODERATE_PENDING_CHANGE_SUCCESS);

export const moderatePendingChangeFailed = actionCreator(ActionTypes.MODERATE_PENDING_CHANGE_FAILED);

export const fetchPendingChanges = actionCreator(ActionTypes.FETCH_PENDING_CHANGES);

export const fetchPendingChangesSuccess = actionCreator(ActionTypes.FETCH_PENDING_CHANGES_SUCCESS);

export const fetchPendingChangesFailed = actionCreator(ActionTypes.FETCH_PENDING_CHANGES_FAILED);

export const changePendingChangesStore = actionCreator(ActionTypes.CHANGE_PENDING_CHANGES_STORE);

export const clearPendingChangesErrorState = actionCreator(ActionTypes.CLEAR_PENDING_CHANGES_ERROR_STATE);